import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

interface ProtectedRouteProps {
    menuId: number;
    children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ menuId, children }) => {
    const { menus, submenus } = useSelector((state: any) => state.auth);
    const allowed = [...(menus ?? []), ...(submenus ?? [])];

    if (!allowed.includes(menuId)) {
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;